import 'client-only';

const INSTALLATION_ID_KEY = 'com.popshop.installation.key';

/**
 * Stable per-browser installation id, persisted in `localStorage`. Sent as the
 * `X-Device-ID` header on every backend call (directly via `withClientAPI`, or
 * forwarded through the visitor-proxy via `proxyFetch`); some endpoints — e.g.
 * guest-account creation — reject the request without it. Returns `''` on the
 * server, where there is no device.
 */
export function getDeviceId(): string {
  if (typeof window === 'undefined') return '';
  let deviceId = localStorage.getItem(INSTALLATION_ID_KEY);
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(INSTALLATION_ID_KEY, deviceId);
  }
  return deviceId;
}
